import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { map } from 'lodash';
import CopyText from 'src/components/common/CopyText';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

const RelatedHsCode = ({ selected }: { selected?: TypeSingleHSCodePrediction }) => {
  const {
    palette: { common },
    shape: { borderRadius },
  } = useTheme();
  return (
    <Box>
      <Box
        textAlign={'center'}
        p={2}
        sx={{
          background: 'linear-gradient(180deg, #7551FF 0%, #3311DB 100%)',
        }}
        borderRadius={`${borderRadius * 2}px ${borderRadius * 2}px 0px 0px`}
      >
        <Typography variant="subtitle1" color={common.white}>
          Related HS Codes
        </Typography>
      </Box>
      <WhiteBoxContent padding={0} maxHeight={500} overflow={'auto'}>
        <Stack divider={<Divider />} spacing={2} margin={2}>
          {map(selected?.related_hscodes, (hsCode, index) => (
            <Stack alignItems={'stretch'} direction={'column'} spacing={1} key={`related-hs-code-${index}`}>
              <Typography color={'secondary.main'} variant="subtitle1">
                {hsCode?.code}
                <CopyText text={hsCode?.code} />
              </Typography>
              <Typography mt={1} color={'text.secondary'} variant="body2">
                {hsCode?.description}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </WhiteBoxContent>
    </Box>
  );
};
export default RelatedHsCode;
